const RAW_BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/+$/, '');
const BACKEND_URL = RAW_BACKEND_URL.endsWith('/api') ? RAW_BACKEND_URL.slice(0, -4) : RAW_BACKEND_URL;

export const API = `${BACKEND_URL}/api`;
